import { comics } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';
import SectionTitle from '@/components/feature/SectionTitle';

export default function FeaturedSection() {
  const featured = comics.filter((c) => c.rating >= 4.7).slice(0, 6);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <SectionTitle
          label="热门推荐"
          title="本周最受欢迎的韩漫"
          subtitle="根据阅读量和用户评分精选，不容错过的优质韩国漫画"
        />

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {featured.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}